import React, { FC, ReactNode } from 'react';
import styles from './aside_search_snippet_header.module.scss';

type Props = {
  title: ReactNode;
};

export const AsideSearchSnippetHeader: FC<Props> = ({ title, children }) => (
  <div className={styles.container}>
    <span className={styles.title}>{title}</span>
    {children}
  </div>
);
